/**
 * Keeping our own visits out of the numbers. The twin of `landing-page/src/internalTraffic.js`
 *, same flag, same URL switch, set once per browser per domain.
 *
 * PostHog's own "Filter out internal and test users" matches person properties such as an email,
 * which works here (we are signed in) but not on the marketing site, where every visitor is
 * anonymous. One mechanism that covers both is worth more than two that each cover half, and a
 * browser that sends nothing is cleaner than one that sends tagged events every query has to
 * remember to exclude.
 */
const KEY = 'flowgate.internal';

/**
 * Applies `?internal=1` / `?internal=0` from the URL, then answers whether this browser counts.
 *
 * @returns {boolean} true when this browser is ours and analytics should stay off.
 */
export function isInternalTraffic() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const wanted = new URLSearchParams(window.location.search).get('internal');
    if (wanted === '1') {
      window.localStorage.setItem(KEY, '1');
    } else if (wanted === '0') {
      window.localStorage.removeItem(KEY);
    }
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    // Private browsing can refuse storage. A visitor we cannot mark is a visitor we count.
    return false;
  }
}

export default isInternalTraffic;
